module.exports = __webpack_public_path__ + "assets/img/26-m.857fae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/26-m.jpg
// module id = 0Vjx
// module chunks = 0